/* K.Teran: product image zoom START */
(function () {
  'use strict';

  function bigSrc(src) {
    if (!src) return src;
    return src.replace(/width=\d+/, 'width=2000');
  }

  function collectImages() {
    var list = [];
    var seen = {};

    document.querySelectorAll('.pd-gallery__stage img, .pd-thumb img').forEach(function (img) {
      var src = img.currentSrc || img.src;
      if (!src || seen[src]) return;
      seen[src] = true;
      list.push({
        src: bigSrc(src),
        thumb: src
      });
    });

    return list;
  }

  function ensureLightbox() {
    var el = document.getElementById('ncd-lb');
    if (el) return el;

    el = document.createElement('div');
    el.id = 'ncd-lb';
    el.className = 'ncd-lb';
    el.innerHTML =
      '<button class="ncd-lb__close" type="button" aria-label="Close">&times;</button>' +
      '<div class="ncd-lb__stage">' +
        '<button class="ncd-lb__prev" type="button" aria-label="Previous">‹</button>' +
        '<img class="ncd-lb__img" alt="">' +
        '<button class="ncd-lb__next" type="button" aria-label="Next">›</button>' +
      '</div>' +
      '<div class="ncd-lb__thumbs"></div>';
    document.body.appendChild(el);
    return el;
  }

  var state = { items: [], index: 0 };

  function render() {
    var lb = ensureLightbox();
    if (!state.items.length) return;

    var item = state.items[state.index];
    var img = lb.querySelector('.ncd-lb__img');
    img.src = item.src;

    var thumbs = lb.querySelector('.ncd-lb__thumbs');
    thumbs.innerHTML = '';
    state.items.forEach(function (it, i) {
      var t = document.createElement('img');
      t.className = 'ncd-lb__thumb' + (i === state.index ? ' is-active' : '');
      t.src = it.thumb;
      t.addEventListener('click', function (e) {
        e.stopPropagation();
        state.index = i;
        render();
      });
      thumbs.appendChild(t);
    });
  }

  function openAt(index) {
    state.items = collectImages();
    if (!state.items.length) return;
    state.index = Math.max(0, Math.min(index, state.items.length - 1));
    ensureLightbox().classList.add('is-open');
    document.body.style.overflow = 'hidden';
    render();
  }

  function close() {
    var lb = document.getElementById('ncd-lb');
    if (lb) lb.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function next() {
    if (!state.items.length) return;
    state.index = (state.index + 1) % state.items.length;
    render();
  }

  function prev() {
    if (!state.items.length) return;
    state.index = (state.index - 1 + state.items.length) % state.items.length;
    render();
  }

  function currentIndexFromSrc(src) {
    var items = collectImages();
    var big = bigSrc(src);
    for (var i = 0; i < items.length; i++) {
      if (items[i].src === big || items[i].thumb === src) return i;
    }
    return 0;
  }

    document.addEventListener('click', function (e) {
    var lb = document.getElementById('ncd-lb');

    // lightbox kontrole
    if (lb && lb.classList.contains('is-open')) {
      if (e.target.closest('.ncd-lb__close')) {
        close();
        return;
      }
      if (e.target.closest('.ncd-lb__next')) {
        next();
        return;
      }
      if (e.target.closest('.ncd-lb__prev')) {
        prev();
        return;
      }
      if (e.target === lb || e.target.classList.contains('ncd-lb__stage')) {
        close();
      }
      return;
    }

    // puščice / gumbi v galeriji — ne odpri lightbox
    if (e.target.closest(
      '.pd-gallery__prev, .pd-gallery__next, .pd-thumb, button, a, [class*="prev"], [class*="next"], [class*="arrow"]'
    )) {
      return;
    }

    // samo klik na sliko v stage
    var img = e.target.closest('.pd-gallery__stage img');
    if (img) {
      e.preventDefault();
      openAt(currentIndexFromSrc(img.currentSrc || img.src));
    }
  });

  document.addEventListener('keydown', function (e) {
    var lb = document.getElementById('ncd-lb');
    if (!lb || !lb.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowRight') next();
    if (e.key === 'ArrowLeft') prev();
  });
})();
/* K.Teran: product image zoom END */